module.exports = __webpack_public_path__ + "img/zizhi13.af9a88e4.png";